import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// --- DEBUGGING ---

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("CRITICAL ERROR: Root element with id 'root' not found in the DOM.");
}

